import React, { memo } from "react";
import { SkeletonTheme } from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

type AppSkeletonThemeProps = {
  children: React.ReactNode;
  /** Mặc định gần EXPLORER_CHIP_BG */
  baseColor?: string;
  highlightColor?: string;
  borderRadius?: string;
  duration?: number;
};

/**
 * Theme chung cho react-loading-skeleton (explorer, plants, …).
 */
const AppSkeletonTheme: React.FC<AppSkeletonThemeProps> = ({
  children,
  baseColor = "#e8ece8",
  highlightColor = "#f2f5f2",
  borderRadius = "10px",
  duration = 1.15,
}) => (
  <SkeletonTheme
    baseColor={baseColor}
    highlightColor={highlightColor}
    borderRadius={borderRadius}
    duration={duration}
  >
    {children}
  </SkeletonTheme>
);

export default memo(AppSkeletonTheme);
